<template>
  <b-modal
    id="DPRScripts"
    content-class="menu-bg-blue-transparent-modal"
    title="Daily Productivity Report Automation Setting"
    hide-footer
   
  >
    <div>
      <b-row class="col-sm-12 p-4 text-center">
        <b-col class="col-sm-6">
          <label class="form-check-label font-weight-bold">
            <input
              class="form-check-input"
              type="radio"
              name="typeFilter"
              value="all"
              title="All Systems"
              v-model="type"
              checked
            />All Systems
          </label>
        </b-col>
        <b-col class="col-sm-6">
          <label class="form-check-label font-weight-bold">
            <input
              class="form-check-input"
              type="radio"
              name="typeFilter"
              value="one"
              title="New System"
              v-model="type"
            />New System
          </label>
        </b-col>
      </b-row>
      <b-card
        v-if="type != 'all'"
        id="generateNewSystemEntriesWindow"
        header-html="<b>Generate Yearly DPR Entries for New System</b>"
        class="hide-hor-scroll p-1 menu-bg-blue-transparent"
        no-body
      >
        <b-form-group class="px-3 py-2">
          <label>Start Date *</label>
          <b-form-input name="startDate" v-model="startDate" type="date" />
        </b-form-group>
        <b-form-group class="px-3 py-2">
          <label>System Id *</label>
          <b-form-input name="systemId" v-model="systemId" />
        </b-form-group>
        <b-row class="p-2" v-if="submitErrors.length > 0">
          <b-col class="text-center">
            <span>
              <b>Please correct the following error(s):</b>
              <b-list-group>
                <div
                  class="alert alert-danger"
                  v-for="error in submitErrors"
                  :key="error"
                >
                  <b-list-group-item>{{ error }}</b-list-group-item>
                </div>
              </b-list-group>
            </span>
          </b-col>
        </b-row>
        <b-row class="p-3">
          <b-col class="text-center">
            <b-button
              variant="primary"
              class="btn-md m-2"
              type="submit"
              @click="runNewSystem()"
            >
              Execute
            </b-button>
          </b-col>
        </b-row>
      </b-card>
      <b-card
        v-if="type == 'all'"
        id="generateEntriesWindow"
        header-html="<b>Generate Yearly DPR Entries</b>"
        class="hide-hor-scroll p-1 menu-bg-blue-transparent"
        no-body
      >
        <b-row class="p-3">
          <b-col class="text-center">
            <b-button
              variant="primary"
              class="btn-md m-2"
              type="submit"
              @click="runAllSystems()"
            >
              Execute
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </b-modal>
</template>

<script>
import axios from 'axios'
export default {
  name: 'MMP_DPRAutomation',
  data() {
    return {
      submitSuccess: [],
      submitErrors: [],
      startDate: null,
      type: 'all',
      systemId: null
    }
  },
  methods: {
    hideMsg() {
      this.submitSuccess = []
      this.submitErrors = []
      this.refreshModal()
      this.type = 'all'
    },
    refreshModal() {
      this.startDate = ''
      this.systemId = null
    },
    check() {
      this.submitErrors = []
      if (this.startDate == null) {
        this.submitErrors.push('Please enter date.')
      }
      if (this.systemId == null) {
        this.submitErrors.push('Please enter system Id.')
      }
    },
    runAllSystems() {
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION +
              '/api/script_automation/generate_dpr_entries_yearly',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              }
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('generate_dpr_entries_yearly API Call Error: ' + content.errors)
            } else {
              this.displayMsg()
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    displayMsg() {
      this.$bvToast.toast('DPR entries are created successfully.', {
        title: 'Status',
        toaster: 'b-toaster-top-center'
      })
    },
    runNewSystem() {
      this.check()
      if (this.submitErrors.length == 0) {
        if (sessionStorage.token) {
          axios
            .get(
              process.env.API_LOCATION +
                '/api/script_automation/generate_dpr_entries_for_system',
              {
                headers: {
                  'x-auth-token': sessionStorage.token
                },
                params: {
                  date: this.startDate,
                  sysId: this.systemId
                }
              }
            )
            .then(response => {
              const content = response.data
              if (content.errors) {
                console.log('generate_dpr_entries_for_system API Call Error: ' + content.errors)
              } else {
                this.displayMsg()
                this.refreshModal()
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          console.log('No User Token')
        }
      }
    }
  }
}
</script>
